import { useEffect, useState } from 'react';

export default function useHandoffStages(stages, enabled = true) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!enabled) {
      setIndex(0);
      return undefined;
    }
    setIndex(0);
    const timers = stages.slice(1).map((stage, idx) => (
      window.setTimeout(() => setIndex(idx + 1), stage.at)
    ));
    return () => timers.forEach((id) => window.clearTimeout(id));
  }, [enabled, stages]);

  return stages[index]?.message || stages[0]?.message || '';
}
